import { getDateDifferenceInDays, formatDateAsLongDate, convertDateToNgbDatePicker,
    getLockStatusDescription } from "../../../../sightlines-shared/utils/functions";

export interface IInsuranceStatus {
    lockStatusDescription: string,
    lockStatus: number,
    dueDateId: number,
    dueDate: string,
    dueDateNgbDatePicker: any;
    daysUntilDueDate: number;
    insuranceStatusSchedule: any;
    insuranceStatusLockStatus: any;
}

export class InsuranceStatus implements IInsuranceStatus {
    lockStatusDescription: string;
    lockStatus: number;
    dueDateId: number;
    dueDate: string;
    dueDateNgbDatePicker: any;
    daysUntilDueDate: number;
    insuranceStatusSchedule: any;
    insuranceStatusLockStatus: any;

    constructor(init?: Partial<InsuranceStatus>) {
        Object.assign(this, init.insuranceStatusSchedule);
        this.daysUntilDueDate = getDateDifferenceInDays(init.insuranceStatusSchedule.dueDate);
        this.dueDate = formatDateAsLongDate(init.insuranceStatusSchedule.dueDate);
        this.dueDateNgbDatePicker = convertDateToNgbDatePicker(init.insuranceStatusSchedule.dueDate);
        this.lockStatusDescription = getLockStatusDescription(init.insuranceStatusLockStatus.lockStatus);
    }
}